import React from 'react';
import { Card, Row, Col, Container } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';

const GameSummary = () => {
  const gameSummary = useSelector((state) => state.gameSummary)

  const renderTeam = (teamName, teamData) => (
    <Col md={6}>
      <h5 className="text-center">{teamName}</h5>
      <p><strong>Score:</strong> {teamData.score}</p>
      <p><strong>Total Cards:</strong> {teamData.totalCards}</p>
      <p><strong>ZNK Count:</strong> {teamData.znkCount}</p>
      <p><strong>Has 2♣:</strong> {teamData.has2ofClub ? '✅' : '❌'}</p>
      <p><strong>Has 10♦:</strong> {teamData.has10ofDiamond ? '✅' : '❌'}</p>
    </Col>
  );

  return (
    <Container className="my-4">
          <Row>
            {renderTeam('Team 1', gameSummary.team1Score)}
            {renderTeam('Team 2', gameSummary.team2Score)}
          </Row>
          <h5 className="mb-0">🏁 Result: <span className="text-primary">{gameSummary.winner}</span></h5>
          <small className="text-muted">Game ID: {gameSummary.gameId}</small>
    </Container>
  );
};

export default GameSummary;
